'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

UserCreatedModalController=class UserCreatedModalController extends BaseController{
static get $inject(){
return['$modalInstance','uncaughtErrorHandler','user'];
}

constructor($modalInstance,uncaughtErrorHandler,user){
_.ensureInstanceOf(UserInfo,user);
super(uncaughtErrorHandler);

this._$modalInstance=$modalInstance;
this._user=user;
}

get user(){
return this._user;
}

onOk(){
this._$modalInstance.close();
}};


module.exports=UserCreatedModalController;
//# sourceMappingURL=userCreatedModalController.js.map
